import { observer } from "mobx-react"
import { useShowSubscriptionDialog } from "@features/subscription"
import { useSmartBanner } from "@features/smart-banner"
import { Footer, Header, Page, PureLogo, useStore } from "@features/common"
import { serverSidePagePrepare } from "@lib/hooks"
import { RouterLink } from "@lib/routing"
import { scrollToTop } from "@lib/scroll"
import { IconHamburger } from "@lib/icons"
import {
  HeroComponent,
  CultureComponent,
  BenefitsComponent,
  OurPeopleComponent,
  JobsComponent,
  CareersLogo,
  CareersLogoRU,
} from "@features/careers-page"

export const getServerSideProps = serverSidePagePrepare({
  callback: async ({ Models }) => {
    await Models.VacanciesModel.getVacanciesPage()
    await Models.GlobalModel.getSmartBanner()
  },
})

const VacanciesPage = observer(function VacanciesPage() {
  const {
    GlobalModel: { openMenu, getTemplate, lang },
    BlogModel,
    VacanciesModel,
  } = useStore()
  const { smartBanner } = useSmartBanner()

  useShowSubscriptionDialog()

  const title = getTemplate("careers.title")
  const metaTitle = VacanciesModel.getTemplate("careers.metaTitle") || title
  const metaDescription = VacanciesModel.getTemplate("careers.metaDescription")
  const seoH1 = VacanciesModel.getTemplate("careers.seoH1.title")

  return (
    <Page
      meta={{
        title,
        metaTitle,
        description: metaDescription,
      }}
      smartBanner={smartBanner}
      header={
        <Header
          theme="dark"
          logo={
            <RouterLink
              uri="/careers"
              onClick={() => scrollToTop()}
              data-test-id="header__pure_logo"
              aria-label="root"
              className="mt-4 mb-3 tablet-m:mt-[20px] tablet-m:mb-[18px]"
            >
              <div className="shrink-0 flex items-stretch h-4 tablet-m:h-7">
                <PureLogo className="shrink-0 block h-full w-auto tablet:h-full text-white pr-2 tablet-m:pr-4" />
                {lang === "ru" ? <CareersLogoRU /> : <CareersLogo />}
              </div>
            </RouterLink>
          }
          languageSwitcher={null}
          navigationOpener={
            <button
              onClick={openMenu}
              data-test-id="header__menu_button"
              aria-label="menu"
            >
              <IconHamburger className="w-8 h-8 text-white" />
            </button>
          }
        />
      }
      alternativeHeader
      footer={
        <Footer
          googlePlayLink={BlogModel.branch_links.main_footer_google_play}
          appStoreLink={BlogModel.branch_links.main_footer_app_store}
          appGalleryLink={BlogModel.branch_links.main_footer_app_gallery}
        />
      }
      seoH1={seoH1}
    >
      <HeroComponent />
      <CultureComponent />
      <BenefitsComponent />
      <OurPeopleComponent />
      <JobsComponent />
    </Page>
  )
})

export default VacanciesPage
